var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSm6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon front"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 22.8586H13.5C13.8977 22.8582 14.279 22.7 14.5602 22.4188C14.8414 22.1376 14.9995 21.7563 15 21.3586V19.1086H13.5V21.3586H4.5V3.35864H13.5V5.60864H15V3.35864C14.9995 2.96096 14.8414 2.57969 14.5602 2.29849C14.279 2.01728 13.8977 1.8591 13.5 1.85864H4.5C4.10232 1.8591 3.72105 2.01728 3.43984 2.29849C3.15864 2.57969 3.00046 2.96096 3 3.35864V21.3586C3.00046 21.7563 3.15864 22.1376 3.43984 22.4188C3.72105 22.7 4.10232 22.8582 4.5 22.8586Z",
    fill: "#8D9FB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4395 15.7981L18.129 13.1086H7.5V11.6086H18.129L15.4395 8.91914L16.5 7.85864L21 12.3586L16.5 16.8586L15.4395 15.7981Z",
    fill: "#8D9FB6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSm6);
export default __webpack_public_path__ + "static/media/sm6.ebde87a555c301f217ca571e1b5e380b.svg";
export { ForwardRef as ReactComponent };